/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
if (!customElements.get('modal-cart-dialog')) {
  class ModalCartDialog extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      this.setAttribute('hidden', '');
      this._onKeydown = e => {
        if (!this.classList.contains('is-open') || e.key !== 'Escape') return;
        e.stopPropagation();
        e.preventDefault();
        this.hide();
      };
      this.addEventListener('click', e => {
        const panel = this.querySelector('.qa-panel');
        if (e.target.closest('.qa-close') || e.target.classList && e.target.classList.contains('qa-backdrop') || panel && !panel.contains(e.target)) {
          e.stopImmediatePropagation();
          e.preventDefault();
          this.hide();
        }
      }, true);
    }
    show() {
      this.removeAttribute('hidden');
      this.classList.add('is-open');
      document.addEventListener('keydown', this._onKeydown, true);
      const root = this.querySelector('.qa');
      if (!root || root.__bound) return;
      root.__bound = true;
      const form = root.querySelector('form[data-ajax-add]');
      if (!form) return;
      const parseProduct = () => {
        const el = root.querySelector('[data-product-json]');
        if (!el) return null;
        try {
          return JSON.parse(el.textContent);
        } catch {
          return null;
        }
      };
      const readOptions = () => {
        const map = {};
        new FormData(form).forEach((v, k) => {
          if (k.startsWith('options[')) map[k.slice(8, -1)] = v;
        });
        return map;
      };
      const findVariant = (product, opts) => {
        if (!product) return null;
        return product.variants.find(v => product.options.every((name, i) => String(v.options[i]) === String(opts[name] || ''))) || null;
      };
      const updateDisabledOptions = (product, selected) => {
        product.options.forEach((optName, optIndex) => {
          root.querySelectorAll(`input[name="options[${CSS.escape(optName)}]"]`).forEach(input => {
            let available = product.variants.some(v => {
              if (!v.available) return false;
              return product.options.every((name, i) => {
                if (i === optIndex) return String(v.options[i]) === String(input.value);
                if (selected[name]) return String(v.options[i]) === String(selected[name]);
                return true;
              });
            });
            input.disabled = !available;
          });
        });
      };
      const updateUI = () => {
        const product = root.__product || parseProduct();
        if (!product) return;
        root.__product = product;
        const selected = readOptions();
        updateDisabledOptions(product, selected);
        const variant = findVariant(product, selected);
        const variantInput = form.querySelector('[data-variant-input]');
        if (variantInput && variant) variantInput.value = variant.id;
        const btn = form.querySelector('[data-add-btn]');
        if (btn) btn.disabled = !variant || !variant.available;
        const priceContainer = form.querySelector('.price') || btn?.querySelector('.price');
        if (!priceContainer || !variant) return;
        const currentPrice = (variant.price / 100).toFixed(2);
        const comparePrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;
        const saleSection = priceContainer.querySelector('.price__sale');
        const regularSection = priceContainer.querySelector('.price__regular');
        if (!saleSection || !regularSection) return;
        if (comparePrice && parseFloat(comparePrice) > parseFloat(currentPrice)) {
          regularSection.style.display = 'none';
          saleSection.style.display = 'flex';
          const salePriceEl = saleSection.querySelector('.price-item--sale bdi');
          if (salePriceEl) salePriceEl.textContent = `${currentPrice}€`;
          const compareEl = saleSection.querySelector('.price__compare bdi');
          if (compareEl) compareEl.textContent = `${comparePrice}€`;
        } else {
          regularSection.style.display = 'block';
          saleSection.style.display = 'none';
          const regularPriceEl = regularSection.querySelector('.price-item--regular bdi');
          if (regularPriceEl) regularPriceEl.textContent = `${currentPrice}€`;
        }
      };
      form.addEventListener('change', e => {
        if (e.target.matches('input, select')) updateUI();
      });
      updateUI();
    }
    hide() {
      this.setAttribute('hidden', '');
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this._onKeydown, true);
      if (this.dataset.ephemeral === 'true') this.remove();
    }
  }
  customElements.define('modal-cart-dialog', ModalCartDialog);
}
if (!customElements.get('modal-cart-opener')) {
  class ModalCartOpener extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      const open = () => {
        if (this.__opening) return;
        this.__opening = true;
        requestAnimationFrame(() => {
          this.__opening = false;
        });
        const tpl = this.querySelector('template');
        if (!tpl) return;
        const mount = this.closest('.mini-cart__inner') || this.closest('#cart') || document.querySelector('.mini-cart__inner') || document.body;
        if (mount.querySelector('modal-cart-dialog.is-open')) return;
        const frag = tpl.content.cloneNode(true);
        const dialog = frag.querySelector('modal-cart-dialog');
        if (!dialog) return;
        dialog.dataset.ephemeral = 'true';
        mount.appendChild(frag);
        dialog.show();
      };
      this.addEventListener('click', e => {
        if (!e.target.closest('[data-open]')) return;
        e.preventDefault();
        e.stopPropagation();
        open();
      });
      this.addEventListener('keydown', e => {
        if (!e.target.closest('[data-open]')) return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopPropagation();
        open();
      });
    }
  }
  customElements.define('modal-cart-opener', ModalCartOpener);
}
/******/ })()
;